import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid'
import {useLocation} from "react-router-dom";
import {useMemo} from "react";
import {groupBy} from "lodash";
import {Link} from 'react-router-dom'

const plans = [
  {
    title: 'Starter',
    featured: false,
    description: 'For business who need to maintain basic HR data, and collaborate with their Payroll Bureau, accountants and bookkeepers.',
    priceMonthly: 1,
    priceYearly: 56,
    mainFeatures: [
      { id: 1, value: 'Employee Details' },
      { id: 2, value: 'Employee App' },
      { id: 3, value: 'Vacation Calendar' },
      { id: 4, value: 'Multi User' },
      { id: 5, value: 'Multi Business' },
      { id: 7, value: 'Bureau / Advisor connected' },
    ],
  },
  {
    title: 'Business',
    featured: true,
    description: 'For businesses who want more control with Vacation Management and Time and Attendance',
    priceMonthly: 2,
    priceYearly: 140,
    mainFeatures: [
      { id: 1, value: 'All in Starter' },
      { id: 3, value: 'Vacation Management' },
      { id: 3, value: 'WFH Schedule' },
      { id: 4, value: 'Time & Attendance + Integrations' },
      { id: 5, value: 'WRO Compliant' },
      { id: 6, value: 'LeaveBen™ Calculator' },
      { id: 7, value: 'Payroll' },
    ],
  },
  {
    title: 'Seriously Accurate',
    featured: false,
    description: 'For business who want to pay their employees as accurately as possible.',
    priceMonthly: 3,
    priceYearly: 220,
    mainFeatures: [
      { id: 1, value: 'All in Business' },
      { id: 2, value: 'AccuPay™' },
      { id: 3, value: 'TimesheetPic™' },
      { id: 4, value: 'Sales Integrations' },
      // { id: 5, value: 'Daily Profitability Reports' },
      { id: 6, value: 'Advanced Reports' },
    ],
  },
]
const features = [
  {
    title: 'Basic HR',
    group: 'The Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Chat & Email Support',
    group: 'The Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Bureau / Advisor connected',
    group: 'The Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Employee App',
    group: 'The Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Document Management',
    group: 'The Basics',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: false },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Multi-User',
    group: 'The Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Multi-Business',
    group: 'The Basics',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Absence Management',
    group: 'Leave Management',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Absence Attachments',
    group: 'Leave Management',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Absence Calendar Integration',
    group: 'Leave Management',
    tiers: [
      { title: 'starter', value: 'Coming Soon' },
      { title: 'popular', featured: true, value: 'Coming Soon' },
      { title: 'intermediate', value: 'Coming Soon' },
    ],
  },
  {
    title: 'Absence Reminders',
    group: 'Leave Management',
    tiers: [
      { title: 'starter', value: 'Coming Soon' },
      { title: 'popular', featured: true, value: 'Coming Soon' },
      { title: 'intermediate', value: 'Coming Soon' },
    ],
  },
  {
    title: 'Absence Monthly Summary',
    group: 'Leave Management',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: '+ Cost Reporting' },
    ],
  },
  {
    title: 'Leave Balances',
    group: 'Leave Management',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Timesheets',
    group: 'Time & Attendance',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Time & Attendance Integrations',
    group: 'Time & Attendance',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Punch Clock Integrations',
    group: 'Time & Attendance',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: false },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'TimesheetPic™',
    group: 'Time & Attendance',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: false },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Payroll',
    group: 'Pay',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'LeaveBen™',
    group: 'Leave Management',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'AccuPay™',
    group: 'Time & Attendance',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: false },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'SEPA Bank Payments',
    group: 'Pay',
    country: ['mt'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'BACS Standard 18',
    group: 'Pay',
    country: ['uk'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'BACS XML',
    group: 'Pay',
    country: ['uk'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'One-Click Salary Payments',
    group: 'Pay',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Tax Updates',
    group: 'Local Compliance',
    country: ['mt','uk'],
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Automatic NIC Letters',
    group: 'Local Compliance',
    country: ['uk'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Pensions & Auto Enrolment',
    group: 'Local Compliance',
    country: ['uk'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'P45 / P60',
    group: 'Local Compliance',
    country: ['uk'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'HMRC RTI',
    group: 'Local Compliance',
    country: ['uk'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'CIS 300',
    group: 'Local Compliance',
    country: ['uk'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'EPS / FPS',
    group: "Local Compliance",
    country: ["uk"],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Automatic Sick Benefits',
    group: 'Local Compliance',
    country: ['mt'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Unpaid Sick based on WRO',
    group: 'Local Compliance',
    country: ['mt'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'FS3 / FS5 & FS7',
    group: 'Local Compliance',
    country: ['mt'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'FSS Submissions',
    group: 'Local Compliance',
    country: ['mt'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'FS4',
    group: 'Local Compliance',
    country: ['mt'],
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: 'Coming Soon' },
      { title: 'intermediate', value: 'Coming Soon' },
    ],
  },
  {
    title: 'Parental Leave',
    group: 'Local Compliance',
    country: ['mt'],
    tooltip: 'Add Children date of births for automatic handling of available parental leave allocations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: 'Coming Soon' },
      { title: 'intermediate', value: 'Coming Soon' },
    ],
  },
  {
    title: 'Easy PT/FT/Marriage Switch',
    group: 'Local Compliance',
    country: ['mt'],
    tooltip: 'No need to terminate and re-engage employees, just update their configuration and you are good to go',
    tiers: [
      { title: 'starter', value: true },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Xero',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'FreeAgent',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'QuickBooks',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Sage',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: 'Coming Soon' },
      { title: 'intermediate', value: 'Coming Soon' },
    ],
  },
  {
    title: 'FreshBooks',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: 'Coming Soon' },
      { title: 'intermediate', value: 'Coming Soon' },
    ],
  },
  {
    title: 'Workforce.com',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: 'Leave Only' },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Deputy',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: 'Leave Only' },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Time Moto',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: false },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'ZK Teco',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: false },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Bamboo HR',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Telleroo',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
  {
    title: 'Fyorin',
    group: 'Integrations',
    tiers: [
      { title: 'starter', value: false },
      { title: 'popular', featured: true, value: true },
      { title: 'intermediate', value: true },
    ],
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Example() {
  let location = useLocation();

  const countryCode = location.pathname.split('/')[1]
  const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null

  const {groupedFeatures,currencySign,currency} = useMemo(() => {

    const countryFeatures = features.filter(feature => !feature.country || feature.country.includes(country))
    const groupedFeatures = groupBy(countryFeatures, 'group')

    const currencySign = country === 'uk' ? '£' : '€'
    const currency = country === 'uk' ? "GBP" : "EUR"

    return {groupedFeatures,currencySign,currency}
  }, [country]);
  const hideUkPricing = country === 'uk'
  const trialStartLink = `/${country ?? 'mt'}/start`
  return (
    <div className="bg-gray-50">
      <div className="relative bg-employer-900">
        {/* Overlapping background */}
        <div aria-hidden="true" className="absolute bottom-0 hidden h-6 w-full bg-gray-50 lg:block" />

        <div className="relative mx-auto max-w-2xl px-4 pt-16 text-center sm:px-6 sm:pt-32 lg:max-w-7xl lg:px-8">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
            <span className="block lg:inline">
              {hideUkPricing ? 'Enterprise-grade payroll. Expert-led from day one.' : 'Simple & Transparent pricing'}
            </span>
            {/*<span className="block lg:inline">no commitment.</span>*/}
          </h1>
          <p className="mt-4 text-xl text-employer-100">
            {hideUkPricing
              ? 'Buddy is a modern payroll platform built to handle real-world complexity. Our specialists help you choose the right setup, so you get the full power of the platform — without overpaying or overcomplicating things.'
              : 'Everything you need. Pick a plan that best suits your business.'}
          </p>
        </div>

        <h2 className="sr-only">Plans</h2>

        {hideUkPricing && (
          <div className="relative mx-auto mt-8 max-w-2xl px-4 pb-8 sm:mt-12 sm:px-6 lg:max-w-5xl lg:px-8">
            <div className="rounded-lg border border-gray-200 bg-white px-6 py-8 shadow-sm">
              <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-employer-900">Why our pricing starts with a conversation</h3>
                  <p className="mt-2 text-sm text-gray-600">
                    Payroll isn’t priced by employee count alone. Things like approval flows, multiple entities, pensions,
                    integrations, and bureau workflows all matter.
                  </p>
                  <ul className="mt-4 space-y-1 text-sm text-gray-600">
                    <li>One powerful platform across all plans</li>
                    <li>Flexible pricing based on how you actually use payroll</li>
                    <li>Expert guidance to make sure you don’t pay for things you don’t need</li>
                  </ul>
                  <p className="mt-4 text-sm text-gray-600">
                    You’ll receive a clear recommendation — and pricing — before you commit.
                  </p>
                </div>
                <div className="flex w-full flex-col gap-3 sm:w-auto">
                  <a
                    href={trialStartLink}
                    className="flex items-center justify-center rounded-md border border-transparent bg-employer-900 px-5 py-3 text-base font-medium text-white hover:bg-employer-700"
                  >
                    Get your recommended plan
                  </a>
                  <a
                    href={trialStartLink}
                    className="flex items-center justify-center rounded-md border border-employer-900 bg-white px-5 py-3 text-base font-medium text-employer-900 hover:bg-employer-50"
                  >
                    Speak to a payroll specialist
                  </a>
                  <p className="text-xs text-gray-500">
                    Trusted by growing UK payroll teams • Clear pricing before you commit
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {hideUkPricing && (
          <div className="relative mx-auto max-w-2xl px-4 pb-2 sm:px-6 lg:max-w-5xl lg:px-8">
            <h3 className="text-lg font-semibold text-white">One platform. Configured to fit your payroll.</h3>
            <p className="mt-2 text-sm text-employer-100">
              Every Buddy customer runs on the same robust payroll engine. What changes is the level of automation,
              control, and scale you need — and we help you get that right from the start.
            </p>
          </div>
        )}

        {/* Toggle */}
        {/*<div className="relative mt-12 flex justify-center sm:mt-16">
          <div className="flex rounded-lg bg-employer-700 p-0.5">
            <button
              type="button"
              className="relative whitespace-nowrap rounded-md border-employer-700 bg-white py-2 px-6 text-sm font-medium text-employer-700 shadow-sm hover:bg-employer-50 focus:z-10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-employer-700"
            >
              Monthly billing
            </button>
            <button
              type="button"
              className="relative ml-0.5 whitespace-nowrap rounded-md border border-transparent py-2 px-6 text-sm font-medium text-employer-200 hover:bg-employer-800 focus:z-10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-employer-700"
            >
              Yearly billing
            </button>
          </div>
        </div>*/}

        {/* Cards */}
        <div className="relative mx-auto mt-8 max-w-2xl px-4 pb-8 sm:mt-12 sm:px-6 lg:max-w-7xl lg:px-8 lg:pb-0">
            {/* Decorative background */}
            <div
              aria-hidden="true"
              className="absolute inset-0 top-4 bottom-6 left-8 right-8 hidden rounded-tl-lg rounded-tr-lg bg-employer-700 lg:block"
            />

            <div className="relative space-y-6 lg:grid lg:grid-cols-3 lg:space-y-0">
              {plans.map((plan) => (
                <div
                  key={plan.title}
                  className={classNames(
                    plan.featured ? 'bg-white ring-2 ring-employer-700 shadow-md' : 'bg-employer-700 lg:bg-transparent',
                    'pt-6 px-6 pb-3 rounded-lg lg:px-8 lg:pt-12'
                  )}
                >
                  <div>
                    <h3
                      className={classNames(plan.featured ? 'text-employer-900' : 'text-white', 'text-base font-semibold')}
                    >
                      {plan.title}
                    </h3>
                    <div className="flex flex-col items-start sm:flex-row sm:items-center sm:justify-between lg:flex-col lg:items-start">
                      <div className="mt-3 flex items-center">
                        {hideUkPricing ? (
                          <p className={classNames(plan.featured ? 'text-employer-900' : 'text-white', 'text-base font-semibold')}>
                            Expert-led plan recommendations
                          </p>
                        ) : (
                          <>
                            <p
                              className={classNames(
                                plan.featured ? 'text-employer-900' : 'text-white',
                                'text-4xl font-bold tracking-tight'
                              )}
                            >
                              {currencySign}{plan.priceMonthly}
                            </p>
                            <div className="ml-4">
                              <p className={classNames(plan.featured ? 'text-gray-700' : 'text-white', 'text-sm')}>
                                {/*currency*/} / Active Employee<sup>1</sup> / mo
                              </p>
                              {/*
                                <p className={classNames(plan.featured ? 'text-gray-500' : 'text-employer-200', 'text-sm')}>
                                  Billed yearly ({currencySign}{plan.priceYearly})
                                </p>
                              */}
                            </div>
                          </>
                        )}
                      </div>
                      {hideUkPricing ? (
                        <a
                          href={trialStartLink}
                          className={classNames(
                            plan.featured
                              ? 'bg-employer-900 text-white hover:bg-employer-700'
                              : 'bg-white text-employer-900 hover:bg-employer-50',
                            'mt-6 w-full inline-block py-2 px-8 border border-transparent rounded-md shadow-sm text-center text-sm font-medium sm:mt-0 sm:w-auto lg:mt-6 lg:w-full'
                          )}
                        >
                          Get your recommended plan
                        </a>
                      ) : (
                        <a
                          href={trialStartLink}
                          className={classNames(
                            plan.featured
                              ? 'bg-employer-900 text-white hover:bg-employer-700'
                              : 'bg-white text-employer-900 hover:bg-employer-50',
                            'mt-6 w-full inline-block py-2 px-8 border border-transparent rounded-md shadow-sm text-center text-sm font-medium sm:mt-0 sm:w-auto lg:mt-6 lg:w-full'
                          )}
                        >
                          Buy {plan.title}
                        </a>
                      )}
                    </div>
                  </div>
                  <h4 className="sr-only">Features</h4>
                  <ul
                    role="list"
                    className={classNames(
                      plan.featured
                        ? 'border-gray-200 divide-gray-200'
                        : 'border-employer-500 divide-employer-500 divide-opacity-75',
                      'mt-7 border-t divide-y lg:border-t-0'
                    )}
                  >
                    {plan.mainFeatures.map((mainFeature) => (
                      <li key={mainFeature.id} className="flex items-center py-3">
                        <CheckIcon
                          className={classNames(
                            plan.featured ? 'text-employer-500' : 'text-employer-200',
                            'w-5 h-5 flex-shrink-0'
                          )}
                          aria-hidden="true"
                        />
                        <span
                          className={classNames(
                            plan.featured ? 'text-gray-600' : 'text-white',
                            'ml-3 text-sm font-medium'
                          )}
                        >
                          {mainFeature.value}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
      </div>

      {/* Feature comparison (up to lg) */}
      <section aria-labelledby="mobile-comparison-heading" className="lg:hidden">
          <h2 id="mobile-comparison-heading" className="sr-only">
            Feature comparison
          </h2>

          <div className="mx-auto max-w-2xl space-y-16 py-16 px-4 sm:px-6">
            {plans.map((plan, mobilePlanIndex) => (
              <div key="plan.title" className="border-t border-gray-200">
                <div
                  className={classNames(
                    plan.featured ? 'border-employer-900' : 'border-transparent',
                    '-mt-px pt-6 border-t-2 sticky top-0 bg-gray-50 z-50'
                  )}
                >
                  <h3 className={classNames(plan.featured ? 'text-employer-900' : 'text-gray-900', 'text-sm font-bold')}>
                    {plan.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">{plan.description}</p>
                </div>

                {
                  Object.keys(groupedFeatures)?.map(group => (
                      <>
                        <h4 className="mt-10 text-sm font-bold text-gray-900">{group}</h4>

                        <div className="relative mt-6">
                          {/* Fake card background */}
                          <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden sm:block">
                            <div
                              className={classNames(
                                plan.featured ? 'shadow-md' : 'shadow',
                                'absolute right-0 w-1/2 h-full bg-white rounded-lg'
                              )}
                            />
                          </div>

                          <div
                            className={classNames(
                              plan.featured ? 'ring-2 ring-employer-900 shadow-md' : 'ring-1 ring-black ring-opacity-5 shadow',
                              'relative py-3 px-4 bg-white rounded-lg sm:p-0 sm:bg-transparent sm:rounded-none sm:ring-0 sm:shadow-none'
                            )}
                          >
                            <dl className="divide-y divide-gray-200">
                              {groupedFeatures[group].map((feature) => (
                                <div
                                  key={feature.title}
                                  className="flex items-center justify-between py-3 sm:grid sm:grid-cols-2"
                                >
                                  <dt className="pr-4 text-sm font-medium text-gray-900">{feature.title}</dt>
                                  <dd className="flex items-center justify-end sm:justify-center sm:px-4">
                                    {typeof feature.tiers[mobilePlanIndex].value === 'string' ? (
                                      <span
                                        className={classNames(
                                          feature.tiers[mobilePlanIndex].featured ? 'text-employer-900' : 'text-gray-900',
                                          'text-sm font-medium'
                                        )}
                                      >
                                        {feature.tiers[mobilePlanIndex].value}
                                      </span>
                                    ) : (
                                      <>
                                        {feature.tiers[mobilePlanIndex].value === true ? (
                                          <CheckIcon className="mx-auto h-5 w-5 text-employer-900" aria-hidden="true" />
                                        ) : (
                                          <XMarkIcon className="mx-auto h-5 w-5 text-gray-400" aria-hidden="true" />
                                        )}

                                        <span className="sr-only">
                                          {feature.tiers[mobilePlanIndex].value === true ? 'Yes' : 'No'}
                                        </span>
                                      </>
                                    )}
                                  </dd>
                                </div>
                              ))}
                            </dl>
                          </div>

                          {/* Fake card border */}
                          <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden sm:block">
                            <div
                              className={classNames(
                                plan.featured ? 'ring-2 ring-employer-900' : 'ring-1 ring-black ring-opacity-5',
                                'absolute right-0 w-1/2 h-full rounded-lg'
                              )}
                            />
                          </div>
                        </div>
                      </>
                  ))
                }

              </div>
            ))}
          </div>
        </section>

      {!hideUkPricing && (
        <div className="mx-auto max-w-md lg:max-w-5xl -mt-2">
          <span className="text-xs ml-3">* All prices are excluding VAT</span>
        </div>
      )}

       <div className="relative mx-auto mt-4 max-w-7xl px-4 sm:px-6 lg:mt-5 lg:px-8 pb-8">
        <div className="mx-auto max-w-md lg:max-w-5xl">
          <div className="rounded-lg bg-advisor-900 px-6 py-8 sm:p-10 lg:flex lg:items-center">
            <div className="flex-1">
              <div>
                <h3 className="inline-flex rounded-full bg-white px-4 py-1 text-base font-semibold text-advisor-800">
                  Are you a Payroll Bureau?
                </h3>
              </div>
              <div className="mt-4 text-lg text-white">
                Do you offer Payroll as a service?
                Discover how our unique partner packages, can help you grow your practice.
              </div>
            </div>
            <div className="mt-6 rounded-md shadow lg:mt-0 lg:ml-10 lg:flex-shrink-0">
              <Link
                to={`/${countryCode}/payroll-bureau/pricing`}
                className="flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-gray-900 hover:bg-gray-50"
              >
                Discover our Payroll Bureau Offering
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Feature comparison (lg+) */}
      <section aria-labelledby="comparison-heading" className="hidden lg:block">

          <div className="mx-auto max-w-7xl py-24 px-8">
            <h2 className="mt-auto text-sm font-bold text-gray-900">Flexible Pay-As-You-Go and Scalable Pricing Options</h2>
            <p className={'text-gray-600 text-sm mb-3 mt-1'}>
              Our flexible Pay-As-You-Go pricing allows you to tailor subscription plans according to your specific needs.
            </p>
            <div className="flex w-full items-stretch border-t border-gray-200 sticky bg-gray-50 mb-1 z-50 top-0">
              <div className="-mt-px flex w-1/4 items-end py-6 pr-4">
                <h3 className="mt-auto text-sm font-bold text-gray-900">Compare Plans</h3>
              </div>
              {plans.map((plan, planIdx) => (
                <div
                  key={plan.title}
                  aria-hidden="true"
                  className={classNames(planIdx === plans.length - 1 ? '' : 'pr-4', '-mt-px pl-4 w-1/4')}
                >
                  <div
                    className={classNames(plan.featured ? 'border-employer-900' : 'border-transparent', 'py-6 border-t-2')}
                  >
                    <p className={classNames(plan.featured ? 'text-employer-900' : 'text-gray-900', 'text-sm font-bold')}>
                      {plan.title}
                    </p>
                    <p className="mt-2 text-sm text-gray-500">{plan.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {
              Object.keys(groupedFeatures).map((group) => (
                  <>
                    <h3 className="mt-10 text-sm font-bold text-gray-900">{group}</h3>
                     <div className="relative">
                        {/* Fake card backgrounds */}
                        <div className="pointer-events-none absolute inset-0 flex items-stretch" aria-hidden="true">
                          <div className="w-1/4 pr-4" />
                          <div className="w-1/4 px-4">
                            <div className="h-full w-full rounded-lg bg-white shadow" />
                          </div>
                          <div className="w-1/4 px-4">
                            <div className="h-full w-full rounded-lg bg-white shadow-md" />
                          </div>
                          <div className="w-1/4 pl-4">
                            <div className="h-full w-full rounded-lg bg-white shadow" />
                          </div>
                        </div>

                        <table className="relative w-full">
                          <caption className="sr-only">Business feature comparison</caption>
                          <thead>
                            <tr className="text-left">
                              <th scope="col">
                                <span className="sr-only">Feature</span>
                              </th>
                              {plans.map((plan) => (
                                <th key={plan.title} scope="col">
                                  <span className="sr-only">{plan.title} plan</span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-100">
                            {groupedFeatures[group].map((feature) => (
                              <tr key={feature.title}>
                                <th scope="row" className="w-1/4 py-3 pr-4 text-left text-sm font-medium text-gray-900">
                                  {feature.title}
                                </th>
                                {feature.tiers.map((tier, tierIdx) => (
                                  <td
                                    key={tier.title}
                                    className={classNames(
                                      tierIdx === feature.tiers.length - 1 ? 'pl-4' : 'px-4',
                                      'relative w-1/4 py-0 text-center'
                                    )}
                                  >
                                    <span className="relative h-full w-full py-3">
                                      {typeof tier.value === 'string' ? (
                                        <span
                                          className={classNames(
                                            tier.featured ? 'text-employer-900' : 'text-gray-900',
                                            'text-sm font-medium'
                                          )}
                                        >
                                          {tier.value}
                                        </span>
                                      ) : (
                                        <>
                                          {tier.value === true ? (
                                            <CheckIcon className="mx-auto h-5 w-5 text-employer-900" aria-hidden="true" />
                                          ) : (
                                            <XMarkIcon className="mx-auto h-5 w-5 text-gray-400" aria-hidden="true" />
                                          )}

                                          <span className="sr-only">{tier.value === true ? 'Yes' : 'No'}</span>
                                        </>
                                      )}
                                    </span>
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Fake card borders */}
                        <div className="pointer-events-none absolute inset-0 flex items-stretch" aria-hidden="true">
                          <div className="w-1/4 pr-4" />
                          <div className="w-1/4 px-4">
                            <div className="h-full w-full rounded-lg ring-1 ring-black ring-opacity-5" />
                          </div>
                          <div className="w-1/4 px-4">
                            <div className="h-full w-full rounded-lg ring-2 ring-employer-900 ring-opacity-100" />
                          </div>
                          <div className="w-1/4 pl-4">
                            <div className="h-full w-full rounded-lg ring-1 ring-black ring-opacity-5" />
                          </div>
                        </div>
                     </div>
                  </>
              ))
            }
          </div>
        </section>

    </div>
  )
}
